module.exports = __webpack_public_path__ + "img/chevron-small-icon.f99a0ef6.svg";